import * as ReactAccordion from "@radix-ui/react-accordion";
import styled from "styled-components";

export const ReactAccordionRoot = styled(ReactAccordion.Root)`
  position: relative;

  &::before {
    content: "";
    position: absolute;
    top: -2px;
    left: -2px;
    width: 10px;
    height: 10px;
    background-color: red;
    border-radius: 50%;
    animation: pulse 1s infinite;
  }

  @keyframes pulse {
    0%,
    100% {
      transform: scale(1);
      opacity: 1;
    }
    50% {
      transform: scale(1.4);
      opacity: 0.6;
    }
  }
`;

export const AccordionItem = styled(ReactAccordion.Item)`
  box-shadow: 2px 4px 4px rgba(208, 210, 218, 0.25),
    0px 18px 32px rgba(208, 210, 218, 0.15);
  background-color: #ffffff;
  border-radius: 10px;
  overflow: hidden;
  margin-bottom: 16px;
`;

export const AccordionTrigger = styled(ReactAccordion.Trigger)`
  padding: 16px 20px;
  width: 100%;
  background-color: transparent;
  border: none;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 16px;
  line-height: 1.2;
  font-family: var(--font-secondary);
  font-weight: 500;
  color: #1d297c;

  svg {
    height: 12px;
    fill: #1f4ca0;
    transition: transform 0.3s;
  }

  &[data-state="closed"] {
    svg {
      transform: rotate(-90deg);
    }
  }
`;

export const AccordionContent = styled(ReactAccordion.Content)`
  padding: 0 20px 8px;

  li {
    margin-bottom: 12px;
  }

  ul {
    margin-left: 40px;
  }

  &[data-state="open"] {
    animation: slideDown 0.3s;
  }

  &[data-state="closed"] {
    animation: slideUp 0.3s;
  }

  @keyframes slideDown {
    from {
      height: 0;
    }
    to {
      height: var(--radix-accordion-content-height);
    }
  }

  @keyframes slideUp {
    from {
      height: var(--radix-accordion-content-height);
    }
    to {
      height: 0;
    }
  }
`;
